import { useAppDispatch } from '@/store/hooks';
import { fetchProjectCourse } from '@/store/slices/registrants';
import { useEffect, useRef } from 'react';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

export const useProjectCourse = (
  //TODO IAN: move this when courses work is complete
  channel: number,
  projectUuid: string,
  coursesEnabled: boolean = false
) => {
  const dispatch = useAppDispatch();
  const fetched = useRef(false);

  useEffect(() => {
    if (!channel || !projectUuid || !coursesEnabled || fetched.current) return;

    fetched.current = true;

    dispatch(fetchProjectCourse({ channel, projectUuid }))
      .unwrap()
      .catch(() => {
        toastTrigger('Error loading course information', {
          type: EToastTypes.error,
          autoClose: 5000,
        });
      });
  }, [channel, projectUuid, dispatch, coursesEnabled]);
};
